<template>
  <div class="all">
    <div style="position:absolute;left:10px;top:10px;z-index:99999;background-color:white;padding:3px;" @click="send">调用android方法6</div>
    <div id="map"></div>
  </div>
</template>
<script>
import axios from 'axios'
import Qs from 'qs'
import Addr from './../utils/getAPI'
import store from '@/store/index'


import { Dialog, Toast } from 'vant'

export default {
  name: 'all',
  data() {
    return {
      editableLayers: null,
      map: null
    }
  },
  methods: {
    send(){
      console.log(this.editableLayers.getLayers()[0].toGeoJSON());
      if(window.Android !=null && typeof (window.Android) !="undefined"){
        window.Android.callAndroid("你好，wyk Android")
      }else{
        alert(typeof (window.Android));
      }
    },
    initMap() {
      this.map = L.map('map', {
        minZoom: 2,
        maxZoom: 22,
        center: [45.708783, 126.63579],
        zoom: 16,
        zoomControl: false,
        attributionControl: false,
      })
  
      // 影像
      L.tileLayer(
        "http://t{s}.tianditu.com/DataServer?T=img_w&x={x}&y={y}&l={z}&tk=6d1358c77f564dbaad00b8a479591406", {
                subdomains: ["0", "1", "2", "3", "4", "5", "6", "7"]
            }
      ).addTo(this.map);
      // 地名标注
      L.tileLayer(
        "http://t{s}.tianditu.com/DataServer?T=cva_w&x={x}&y={y}&l={z}&tk=6d1358c77f564dbaad00b8a479591406", {
                subdomains: ["0", "1", "2", "3", "4", "5", "6", "7"]
            }
      ).addTo(this.map);

      this.map.pm.addControls({  
        position: 'topleft',  
        drawCircle: false,  
      });  

    }
  },
  watch: {},
  mounted: function() {
    this.initMap()
  },
  components: {}
}
</script>

<style lang="scss" scoped>
@import "../assets/baseScss";
// @import "vant/lib/index.css";
.all {
  height: 100vh;
  width: 100%;
  margin: 0;
  font-family: Roboto, sans-serif;

  .title {
    // background-image: linear-gradient(45deg,#3a2772 30%,#190b2e 75%);
    //linear-gradient(20deg,rgba(88, 30, 182, 0.9) 20%,rgba(34, 98, 194, 0.9) 50%);
    // background-image:linear-gradient(
    //   45deg,
    //   #0f87e2,
    //   #6149f6
    // );
    position: absolute;
    top: 0px;
    left: 0px;
    z-index: 99999;
    width: 100%;
    background-image: linear-gradient(45deg, #0f87e2, #6149f6);

    color: white;
    text-align: center;
    padding-top: 7px;
    padding-bottom: 7px;
    font-size: 19px;
    font-weight: 550;
    opacity: 0.9;
  }

  #map {
    background-color: black;
    height: 100vh;
    width: 100%;
    margin: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/module-land/index.vue